import React, { Component } from 'react';
import { Breadcrumb, Tabs, Button, Form, Input, Radio, DatePicker, message, Select, Modal } from 'antd';
import { Link } from "react-router-dom";
import './index.less';
import UploadVoucher from './uploadVoucher';
import Upload from 'CMPT/common/Upload';
import { API } from '@/http/api';
import http from '@/http';
import userUtil from "@/utils/user";
import moment from "moment";
import debounce from 'lodash/debounce';
import Table from "CMPT/common/Table";
const { RangePicker } = DatePicker;
const BreadcrumbItem = Breadcrumb.Item;
const { TabPane } = Tabs;

const { Search, TextArea } = Input;

const Option = Select.Option
const RadioGroup = Radio.Group
class UserOrder extends Component {

    state = {
        orderId: '',
        keyword: '',
        payVoucher: '',
        PayOrderVisible: false,
        tempData: {},
        columns: [
            {
                title: "姓名",
                key: "accountName",
                align: "center",
                dataIndex: "accountName",
            },
            {
                title: "手机号码",
                key: "accountPhone",
                align: "center",
                dataIndex: "accountPhone",
            },
            {
                title: "企业名称",
                key: "accountCompanyName",
                align: "center",
                dataIndex: "accountCompanyName",
            },
            {
                title: "充值时间", // 0 表示待审核状态
                key: "createDate",
                align: "center",
                dataIndex: "createDate",
                render: (text, record) => {
                    return (
                        <span>{text ? moment(text).format("YYYY-MM-DD HH:mm") : "-"}</span>
                    );
                },
            },
            {
                title: "订单描述",
                key: "description",
                align: "center",
                dataIndex: "description",
            },
            {
                title: "金额",
                key: "payPrice",
                align: "center",
                dataIndex: "payPrice",
            }, {
                title: "购买次数",
                key: "serviceNumber",
                align: "center",
                dataIndex: "serviceNumber",
            },

            {
                title: "购买凭证",
                key: "payVoucher",
                align: "center",
                dataIndex: "payVoucher",
                render: (text) => {
                    return text ? <div className='img_show_btn' onClick={() => this.imgShow(text)}>查看</div> : '-';
                },
            },
            {
                title: "状态",
                key: "stateName",
                align: "center",
                dataIndex: "stateName",
            },
            {
                title: '操作',
                key: 'operate',
                render: (text, record, index) => {
                    return (<span className="table-operate-btn">
                        {
                            record.stateName !== "成功" ?
                                <span className="operate" onClick={() => this.auditingPayOrder(record)}>审核</span>
                                :
                                ''
                        }

                    </span>)
                }
            }

        ],
        params: {
            pageSize: 10,
            pageNo: 1,
            state: 1
        },
        addRecordList: [],
        currentIndex: 0,
        payMoneyVoucherModal: false,
        upVCode: '',
        sourceList: [],
        supplierArray: [],
        waitApplyNum: 0
    }

    componentDidMount() {
        this.auditList()
        // this.getSourceList()
    }
    auditingPayOrder = (record) => {
        console.log("record", record);
        const config = {
            api: API.valueAddServicegetPayRecordInfo,
            data: {
                orderId: record.id
            }
        };
        http(config).then(res => {
            if (res.code == 200) {
                this.setState({
                    orderId: record.id,
                    PayOrderVisible: true,
                    tempData: res.result,
                    payVoucher: res.result.payVoucher
                })
                this.props.form.setFieldsValue(res.result);
            }
        })
    }
    auditDepositModal = (auditStatus, code) => {
        if (auditStatus == '10') {
            Modal.confirm({
                title: '提示',
                icon: 'none',
                content: <div className='confirm_text'>
                    <div className='confirm_1'>确定已收到款吗？</div>
                    <div className='confirm_2'>说明：确定后将自动为该用户充值</div>
                </div>,
                onOk: () => {
                    this.auditDeposit(code, auditStatus)
                }
            })
        } else {
            Modal.confirm({
                title: '提示',
                icon: 'none',
                content: <div>
                    <TextArea
                        rows={4}
                        onChange={this.onRejectInput}
                        placeholder="请输入驳回理由 （100字以内）"
                        maxLength={100}
                    />
                    <span>说明：驳回后用户可重新发起订单付款</span>
                </div>,
                onOk: () => {
                    this.auditDeposit(code, auditStatus)
                }
            })
        }
    }
    onRejectInput = (e) => {
        this.state.auditRemark = e.target.value;
    };

    goRecord = (code) => {
        this.props.history.push(`/app/crm/valueaddService/trajectoryFind/operaterRecord/${code}`)
    }

    auditDeposit = (code, auditStatus) => {
        const config = {
            api: API.valueAddServiceAuditDeposit,
            showLoading: true,
            data: {
                code,
                auditStatus
            }
        };
        let { auditRemark } = this.state;
        if (auditStatus == '20') {
            config.data.auditRemark = auditRemark;
        }
        http(config).then(res => {
            if (res.code == 200) {
                message.success('操作成功')
                this.auditList()
            }
        })
    }

    getSourceList = () => {
        const config = {
            api: API.valueAddServiceGetSourceList,
            showLoading: true,
        };
        http(config).then(res => {
            if (res.code == 200) {
                this.setState({
                    sourceList: res.data
                })
            }
        })
    }

    imgShow = (list) => {
        this.setState({
            imgList: list,
            previewVisible: true
        })
    }
    closeImagePreview = () => {
        this.setState({
            previewVisible: false
        })
    }
    closePayOrderview = () => {
        this.setState({
            PayOrderVisible: false
        })
    }

    auditList = () => {
        let { params } = this.state;
        const config = {
            api: API.valueAddServiceAuditList,
            showLoading: true,
            data: params
        };
        http(config).then(res => {
            if (res.code == 200) {
                this.setState({
                    addRecordList: res.result
                })
                if (params.state == 1) {
                    this.setState({
                        waitApplyNum: res.result.total
                    })
                }
            }
        })
    }

    rangeChange = (value, date) => {
        let params = this.state.params;
        params.startDate = date[0];
        params.endDate = date[1];
        this.setState({
            params,
            startDate: value[0],
            endDate: value[1]
        }, () => {
            this.auditList();
        })
    }

    changeSource = (e) => {
        let params = this.state.params;
        params.tenantCode = e;
        this.setState({
            params,
        }, () => {
            this.auditList();
        })
    }

    changeSupplier = (e) => {
        let params = this.state.params;
        params.supplierId = e;
        this.setState({
            params,
        }, () => {
            this.auditList();
        })
    }

    searchChange = (e) => {
        this.setState({
            keyword: e.target.value
        })
    }

    onSearchOn = (e) => {
        let { params } = this.state;
        params.keyword = e;
        this.setState({
            params
        }, () => {
            this.auditList()
        })
    }

    changeTabs = (e) => {
        let { params } = this.state;
        params.state = e == 0 ? null : e;
        this.setState({
            params
        }, () => {
            this.auditList()
        })
    }

    resetSearch = () => {
        let { params } = this.state;
        params.keyword = '';
        params.startDate = '';
        params.endDate = '';
        params.tenantCode = undefined;
        params.supplierId = undefined;
        this.setState({
            params,
            startDate: undefined,
            endDate: undefined,
            keyword: ''
        }, () => {
            this.auditList()
        })
    }

    payMoneyVoucherModalOk = (payPhotos) => {
        console.log(payPhotos, 'payPhotos');
        let { upVCode } = this.state;
        const config = {
            api: API.valueAddServiceDepositUpload,
            showLoading: true,
            data: {
                code: upVCode,
                payPhotos
            }
        };
        http(config).then(res => {
            if (res.code == 200) {
                message.success('上传成功');
                this.setState({
                    payMoneyVoucherModal: false
                })
                this.auditList()
            }
        })
    }

    payMoneyVoucherModalCancel = () => {
        this.setState({
            payMoneyVoucherModal: false
        })
    }

    inputSearch = (e) => {
        this.searchData(e)
    }

    // 文件上传前拦截
    handleBeforeUpload = file => {
        const size = file.size;
        if (size / 1024 / 1024 > 2) {
            message.error("请上传2M以内的图片");
            return false;
        }
    };
    // 付款凭证上传回调
    payMoneyChange = value => {
        if (value.file.status === "done") {
            let item = value.file.response.file;
            // let { payVoucher } = this.state;
            // payVoucher.push({ name: '', url: item.absolutePath })
            this.setState({ payVoucher: item.absolutePath });
        }
    };
    searchData(name) {
        const config = {
            api: API.invoiceSupplierList,
            path: { supplierName: name || 'null' } // null 表示 全部数据 

        };

        // setup 2:请求，并初步处理
        let _this = this;
        http(config).then(res => {
            if (res && res.code == 200) {
                _this.setState({
                    supplierArray: res.data
                });
            }
        });
    }
    handleSubmit = e => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                const params = {
                    orderId: this.state.orderId,
                    description: values.description,
                    payPrice: values.payPrice,
                    payVoucher: values.payVoucher,
                    serviceNumber: values.serviceNumber,
                }
                const config = {
                    api: API.valueAddServiceauditingPayOrder,
                    data: params
                };
                http(config).then(res => {
                    if (res.code == 200) {
                        this.closePayOrderview();
                        this.auditList();
                        message.success("修改成功")
                    }
                });
                console.log("values", values);
            }
        });
    };
    goSubCharge = () => {
        this.props.history.push('/app/crm/valueaddService/trajectoryFind/subCharge')
    }

    //分页
    onChangePage = (pageNo, pageSize, sort) => {
        this.setState(
            {
                params: {
                    ...this.state.params,
                    pageNo: pageNo,
                    pageSize: pageSize,
                },
            },
            () => {
                this.auditList();
            }
        );
    };

    render() {
        const { keyword, tempData, payVoucher, params, addRecordList, columns, previewVisible, currentIndex, imgList, startDate, endDate, payMoneyVoucherModal, sourceList, supplierArray, waitApplyNum } = this.state;
        const { getFieldDecorator } = this.props.form;
        return (

            <div className="enterprise-auth-con-1">
                <div className='tab_box'>

                    <Button type='primary' className='sub_chart' onClick={this.goSubCharge}>代充</Button>

                    <div className='table_box'>
                        <div className="goods_fliter">
                            <RangePicker value={[startDate, endDate]} onChange={this.rangeChange} style={{ marginRight: '12px' }} />

                            <Search
                                placeholder="姓名/手机号码/企业名称"
                                enterButton="搜索"
                                className="goods_search nomargin"
                                value={keyword}
                                // size="large"
                                onChange={value => { this.searchChange(value) }}
                                onSearch={value => { this.onSearchOn(value) }}
                            />
                            <span className="goods_reset" onClick={this.resetSearch}>重置</span>
                        </div>
                        <Table
                            columns={columns}
                            selfProcessData={addRecordList && addRecordList.records}
                            total={addRecordList && addRecordList.total}
                            change={this.onChangePage}
                            current={addRecordList && addRecordList.current}
                        />
                    </div>
                </div>
                <UploadVoucher
                    payMoneyVoucherModal={payMoneyVoucherModal}
                    payMoneyVoucherModalOk={this.payMoneyVoucherModalOk}
                    payMoneyVoucherModalCancel={this.payMoneyVoucherModalCancel}
                />

                {/* <ImgPreview show={previewVisible} current={currentIndex} imgList={imgList} onClose={this.closeImagePreview} /> */}
                <Modal
                    title=""
                    width='75%'
                    centered={true}
                    visible={this.state.previewVisible}
                    onCancel={this.closeImagePreview}
                    footer={null}
                >
                    <div>
                        <img src={imgList} referrerPolicy="no-referrer" style={{ width: '75%' }} />
                    </div>
                </Modal>
                <Modal
                    title="用户订单审核"
                    visible={this.state.PayOrderVisible}
                    closable={false}
                    maskClosable={false}
                    onCancel={this.closePayOrderview}
                    footer={[]}
                >
                    <div className='account_info'>
                        <div className='list_item'>
                            <span className='label'>企业名称:</span>
                            <span className='contents'>{tempData.accountCompanyName}</span>
                        </div>
                        <div className='list_item'>
                            <span className='label'>姓名:</span>
                            <span className='contents'>{tempData.accountName}</span>
                        </div>
                        <div className='list_item'>
                            <span className='label'>手机号码:</span>
                            <span className='contents'>{tempData.accountPhone}</span>
                        </div>
                        <div className='list_item'>
                            <span className='label'>充值时间:</span>
                            <span className='contents'>{tempData.createDate}</span>
                        </div>
                    </div>
                    <Form onSubmit={this.handleSubmit}>
                        <Form.Item label="充值金额" >
                            {getFieldDecorator(
                                "payPrice", {
                                rules: [{
                                    required: true, message: '请输入',
                                }],
                                // initialValue: params.selectedCategoryType
                            }
                            )(
                                <Input addonAfter="元" placeholder='请输入' />
                            )
                            }
                        </Form.Item>

                        <Form.Item label="充值条数" >
                            {getFieldDecorator(
                                "serviceNumber", {
                                rules: [{
                                    required: true, message: '请输入',
                                }],
                                // initialValue: params.selectedCategoryType
                            }
                            )(
                                <Input addonAfter="次数" placeholder='请输入' type='Number' />
                            )
                            }
                        </Form.Item>

                        <Form.Item label="订单备注" >
                            {getFieldDecorator(
                                "description", {
                            }
                            )(
                                <Input placeholder='请输入' />
                            )
                            }
                        </Form.Item>

                        <Form.Item label="付款凭证" >
                            {getFieldDecorator(
                                "payVoucher", {
                                rules: [{
                                    required: true, message: '请上传',
                                }],
                            }
                            )(
                                <div>
                                    <span>请将付款流水凭证图片上传，并且确认已到账</span>
                                    <div className="upload-img-list">
                                        {/* {payVoucher && payVoucher.map((per, index) => {
                                                            return <img src={per.url} key={index} />
                                                        })} */}
                                        {payVoucher ?
                                            <img src={payVoucher} onClick={() => {
                                                this.imgShow(payVoucher)
                                            }} /> : ''
                                        }
                                        <div className='upload_box'>
                                            <Upload action={API.uploadAdd.url}
                                                beforeUpload={this.handleBeforeUpload}
                                                accept=".png,.jpg"
                                                onChange={this.payMoneyChange}
                                                showUploadList={false}
                                                listType="picture-card">
                                            </Upload>
                                        </div>
                                    </div>

                                </div>

                            )
                            }
                        </Form.Item>

                        <div className="btn-group">
                            <Button type="primary" htmlType="submit">
                                审核通过
                            </Button>
                            <Button onClick={this.closePayOrderview} size="large">
                                取消
                            </Button>
                        </div>
                    </Form>
                </Modal>
            </div>

        );
    }
}

const UserTOrder = Form.create({ name: "UserOrder" })(UserOrder);
export default UserTOrder;